import React from 'react';

export default function FinalSale({
  finalSaleMessage,
}) {
  return (
    <div className="final-sale__container-mfe" data-testid="final-sale__container-mfe">
      {finalSaleMessage}
    </div>
  );
}
